import React, { useCallback } from "react";
import { BottomTools } from "remo-components";
import { RouteNameType } from "../../route-config";
import { usePushHistory } from "../../utils/routes";
import { withRemoServices } from "../RemoServicesContext";
import { channelStore } from "@obsbot/remo-stores";

// 创建包裹后的BottomTools组件
const SideBottomTools: React.FC = withRemoServices("videoChat")(({ videoChat: rtc }) => {
    const pushHistory = usePushHistory();
    const navigateAction = {
        "channel.home": RouteNameType.ChannelPage,
        "setting.rtc": RouteNameType.RTCSettingPage,
    };
    const toOtherPage = useCallback(
        (routeNameType: RouteNameType): void => {
            channelStore.updateUserState({
                mic: false,
                camera: false,
                isListen: false,
            });
            pushHistory(routeNameType);
        },
        [pushHistory],
    );

    const toSetting = (toVideo = false): void => {
        if (toVideo) {
            pushHistory(RouteNameType.RTCSettingPage, {}, { tab: "videoSetting" });
        } else {
            pushHistory(RouteNameType.RTCSettingPage);
        }
    };

    return (
        <BottomTools
            rtc={rtc}
            toSetting={toSetting}
            onHandleLeave={toOtherPage.bind(this, navigateAction["channel.home"])}
        />
    );
});

export default SideBottomTools;
